"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var queryable_1 = require("./queryable");
var siteusers_1 = require("./siteusers");
var util_1 = require("../../utils/util");
(function (PrincipalType) {
    PrincipalType[PrincipalType["None"] = 0] = "None";
    PrincipalType[PrincipalType["User"] = 1] = "User";
    PrincipalType[PrincipalType["DistributionList"] = 2] = "DistributionList";
    PrincipalType[PrincipalType["SecurityGroup"] = 4] = "SecurityGroup";
    PrincipalType[PrincipalType["SharePointGroup"] = 8] = "SharePointGroup";
    PrincipalType[PrincipalType["All"] = 15] = "All";
})(exports.PrincipalType || (exports.PrincipalType = {}));
var PrincipalType = exports.PrincipalType;
var SiteGroups = (function (_super) {
    __extends(SiteGroups, _super);
    function SiteGroups(baseUrl, path) {
        if (path === void 0) { path = "sitegroups"; }
        _super.call(this, baseUrl, path);
    }
    SiteGroups.prototype.add = function (properties) {
        var _this = this;
        var postBody = JSON.stringify(util_1.Util.extend({ "__metadata": { "type": "SP.Group" } }, properties));
        return this.post({ body: postBody }).then(function (data) {
            return {
                data: data,
                group: _this.getById(data.Id),
            };
        });
    };
    SiteGroups.prototype.getByName = function (groupName) {
        return new SiteGroup(this, "getByName('" + groupName + "')");
    };
    SiteGroups.prototype.getById = function (id) {
        var sg = new SiteGroup(this);
        sg.concat("(" + id + ")");
        return sg;
    };
    SiteGroups.prototype.removeById = function (id) {
        var g = new SiteGroups(this, "removeById('" + id + "')");
        return g.post();
    };
    SiteGroups.prototype.removeByLoginName = function (loginName) {
        var g = new SiteGroups(this, "removeByLoginName('" + loginName + "')");
        return g.post();
    };
    return SiteGroups;
}(queryable_1.QueryableCollection));
exports.SiteGroups = SiteGroups;
var SiteGroup = (function (_super) {
    __extends(SiteGroup, _super);
    function SiteGroup(baseUrl, path) {
        _super.call(this, baseUrl, path);
    }
    Object.defineProperty(SiteGroup.prototype, "users", {
        get: function () {
            return new siteusers_1.SiteUsers(this, "users");
        },
        enumerable: true,
        configurable: true
    });
    SiteGroup.prototype.update = function (properties) {
        var _this = this;
        var postBody = util_1.Util.extend({ "__metadata": { "type": "SP.Group" } }, properties);
        return this.post({
            body: JSON.stringify(postBody),
            headers: {
                "X-HTTP-Method": "MERGE",
            },
        }).then(function (data) {
            var retGroup = _this;
            if (properties.hasOwnProperty("Title")) {
                retGroup = _this.getParent(SiteGroup, _this.parentUrl, "getByName('" + properties["Title"] + "')");
            }
            return {
                data: data,
                group: retGroup,
            };
        });
    };
    return SiteGroup;
}(queryable_1.QueryableInstance));
exports.SiteGroup = SiteGroup;
